import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { LojaImportacaoComp } from 'pages/cadastro/loja-importacao/components';

export function LojaImportacao() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['LOJA_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <LojaImportacaoComp />
        </ListagemProvider>
    );
}
